var map = {
	"./mountain-badge--dark.svg": 1481,
	"./mountain-badge--light.svg": 1482,
	"./surf-badge--dark.svg": 1483,
	"./surf-badge--light.svg": 1484,
	"./tide-badge--dark.svg": 1485,
	"./tide-badge--light.svg": 1486,
	"./weather-badge--dark.svg": 1487,
	"./weather-badge--light.svg": 1488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1480;